var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.616 16C1.17133 16 0.791 15.8417 0.475 15.525C0.159 15.2083 0.000666667 14.8287 0 14.386V1.615C0 1.171 0.158333 0.791 0.475 0.475C0.791667 0.159 1.17167 0.000666667 1.615 0H5.885C6.329 0 6.709 0.158333 7.025 0.475C7.341 0.791667 7.49933 1.17167 7.5 1.615V14.385C7.5 14.829 7.34167 15.209 7.025 15.525C6.70833 15.841 6.32833 15.9993 5.885 16H1.616ZM10.116 16C9.67133 16 9.291 15.8417 8.975 15.525C8.659 15.2083 8.50067 14.8283 8.5 14.385V9.615C8.5 9.171 8.65833 8.791 8.975 8.475C9.29167 8.159 9.67167 8.00067 10.115 8H14.385C14.829 8 15.209 8.15833 15.525 8.475C15.841 8.79167 15.9993 9.17167 16 9.615V14.385C16 14.829 15.8417 15.209 15.525 15.525C15.2083 15.841 14.8283 15.9993 14.385 16H10.116ZM10.116 7C9.67133 7 9.291 6.84167 8.975 6.525C8.659 6.20833 8.50067 5.82833 8.5 5.385V1.615C8.5 1.171 8.65833 0.791 8.975 0.475C9.29167 0.159 9.67167 0.000666667 10.115 0H14.385C14.829 0 15.209 0.158333 15.525 0.475C15.841 0.791667 15.9993 1.17167 16 1.615V5.385C16 5.829 15.8417 6.209 15.525 6.525C15.2083 6.841 14.8283 6.99933 14.385 7H10.116Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.56bfe712e8f5e8034e317a9c1674ad8b.svg";
export { ForwardRef as ReactComponent };